import React, { useState, useRef, useEffect } from "react";
import { Form, Button, Col, Row } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faX } from "@fortawesome/free-solid-svg-icons";
import { useUser } from "../../../components/UserContext";
import LoadingContent from "../../../components/LoadingContent";
import { faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { countryCodeToFlag } from "../../../utils/Admin";

const UploadRaceX = ({ data }: { data: any }) => {
  const { user } = useUser() as any;
  const token = window.localStorage.getItem("userLogged");
  const [dataForm, setDataForm] = useState({
    name: "",
    code: "",
  });
  const [validated, setValidated] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [xEmbed, setXEmbed] = useState(``);
  const MAX_CHARS = 280;

  const charCount = xEmbed.length;
  const isOverLimit = charCount > MAX_CHARS;
  const winnersGrouped = Object.values(
    data.winners.reduce(
      (acc: any, winner: any) => {
        if (!acc[winner.username]) {
          acc[winner.username] = {
            username: winner.username,
            country: winner.country,
            count: 0,
          };
        }

        acc[winner.username].count++;

        return acc;
      },
      {} as Record<
        string,
        { username: string; country: string | null; count: number }
      >,
    ),
  );

  const getRaceName = (length: number, type_race: number) => {
    if (length === 2 && type_race === 1) return "Main Race";
    else if (length === 2 && type_race === 2) return "Sprint Race";
  };

  useEffect(() => {
    setXEmbed(
      data.winners.length === 1
        ? [
            `${countryCodeToFlag(data.grand_prix.grand_prix.flag.code)} ${data.grand_prix.name.toUpperCase()} is over.`,
            "",
            `${
              data.winners[0].flag_code
                ? countryCodeToFlag(data.winners[0].flag_code)
                : "🏁"
            } ${data.winners[0].username} takes the victory 🏆`,
            `${
              data.race_results[1].flag_code
                ? countryCodeToFlag(data.race_results[1].flag_code)
                : "🏁"
            } ${data.race_results[1].username} (2º) 🥈`,
            `${
              data.race_results[2].flag_code
                ? countryCodeToFlag(data.race_results[2].flag_code)
                : "🏁"
            } ${data.race_results[2].username} (3º) 🥉`,
            "",
            `🔗 Race results: ${data.results_link}`,
          ].join("\n")
        : data.winners[0].class_name == null
          ? [
              `${countryCodeToFlag(data.grand_prix.grand_prix.flag.code)} ${data.grand_prix.name.toUpperCase()} is over.`,
              "",
              ...data.winners.map((winner: any, index: number) => {
                const flag = winner.flag_code
                  ? countryCodeToFlag(winner.flag_code)
                  : "🏁";

                const position = "🏆";

                return `${flag} ${winner.username} in ${getRaceName(
                  data.winners.length,
                  winner.type_race,
                )} ${position}`;
              }),
              "",
              `🔗 Race results: ${data.results_link}`,
            ].join("\n")
          : [
              `${countryCodeToFlag(data.grand_prix.grand_prix.flag.code)} ${data.grand_prix.name.toUpperCase()} is over.`,
              "",
              ...data.winners.map((winner: any, index: number) => {
                const flag = winner.flag_code
                  ? countryCodeToFlag(winner.flag_code)
                  : "🏁";

                const position =
                  index === 0
                    ? "🏆"
                    : index === 1
                      ? "🥈"
                      : index === 2
                        ? "🥉"
                        : `#${index + 1}`;

                return `${flag} ${winner.username} in ${winner.class_name} ${position}`;
              }),
              "",
              `🔗 Race results: ${data.results_link}`,
            ].join("\n"),
    );
  }, [data]);

  const submitForm = (event: any) => {
    if (token == null) return;
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    const formDataFiles = new FormData();
    formDataFiles.append("x_embed", xEmbed);
    formDataFiles.append("grand_prix_event_id", data.grand_prix_event_id);
    formDataFiles.append("user", user);
    formDataFiles.append("token", JSON.parse(token).token);

    if (!(form !== null && form.checkValidity() === false)) {
      setUploading(true);
      axios
        .post(
          `${
            process.env.NODE_ENV === "development"
              ? "http://localhost:5500"
              : "https://ligavirtualf1.es:5500"
          }/api/admin/publishXRaceResults`,
          formDataFiles,
        )
        .then(() => {
          toast.success("X tweet created successfully");
          setUploading(false);
          setValidated(false);
          setDataForm({ ...dataForm, name: "", code: "" });
        })
        .catch(({ response }) => {
          toast.error("Error: Code duplicated");
          setUploading(false);
          setValidated(false);
          throw new Error(response);
        });
    }
    setValidated(true);
  };

  if (data == null) return <LoadingContent />;
  return (
    <Form
      noValidate
      validated={validated}
      onSubmit={submitForm}
      className="x-form"
    >
      <Row className="mb-3">
        <Form.Group className="form-group col-md-12">
          <h4>
            {" "}
            <FontAwesomeIcon icon={faXTwitter} /> X [Including GP Image]
          </h4>
        </Form.Group>
        <Form.Group className="form-group" as={Col} md="12">
          <div
            style={{
              marginTop: "6px",
              fontSize: "13px",
              textAlign: "right",
              color: isOverLimit ? "red" : "#888",
              fontWeight: isOverLimit ? "bold" : "normal",
            }}
          >
            {charCount} / {MAX_CHARS}
          </div>
          <Form.Label>Tweet (*)</Form.Label>
          <Form.Control
            required
            as="textarea"
            name="discord_embed"
            rows={9}
            value={xEmbed}
            onChange={(e) => setXEmbed(e.target.value)}
          />
          <Form.Control.Feedback type="invalid">
            Field required
          </Form.Control.Feedback>
        </Form.Group>
      </Row>
      <div className="text-center">
        {uploading ? (
          <FontAwesomeIcon icon={faSpinner} className="spinner-button" />
        ) : (
          <Button type="submit" variant="secondary">
            Send X Tweet
          </Button>
        )}
      </div>
    </Form>
  );
};

export default UploadRaceX;
